// extracted by mini-css-extract-plugin
export default {"modalBody":"IDhPKBKEBc7tMEzJIZTN"};